<template>
  <div class="container">
    <a-breadcrumb separator=">">
      <a-breadcrumb-item href="" @click.native="() => $router.push('/')"
        >首页</a-breadcrumb-item
      >
      <a-breadcrumb-item href="" @click.native="() => $router.back()"
        >上一页</a-breadcrumb-item
      >
      <a-breadcrumb-item>检后咨询</a-breadcrumb-item>
    </a-breadcrumb>

    <div class="flex">
      <div>
        <h3>在线咨询</h3>
        <div class="scroll-box">
          <div class="more-msg" @click="moreMsg" v-if="isMoreMsg">
            点击查看更多消息
          </div>
          <div class="more-msg" v-else>没有更多消息</div>
          <div class="scroll-wrapper" ref="scroll">
            <div class="scroll-content">
              <chat-item
                v-for="(item, index) in chatItems"
                :key="index"
                @ItemImageLoad="ItemImageLoad"
                :messageType="item.messageType"
                :message="item.content"
                :timestamp="item.createTime"
                :from="item.fromUserId"
                :doctorNo="selectDoctor.userNo"
              ></chat-item>
            </div>
          </div>
        </div>
        <div class="sendBox">
          <div class="upload-img">
            <a-upload
              :disabled="!isOnlineDoc"
              :data="ossParams"
              name="file"
              :multiple="false"
              accept="image/jpeg,image/jpg,image/png"
              action="https://kangjiu-ch.oss-cn-beijing.aliyuncs.com"
              :showUploadList="false"
              :customRequest="beforeUpload"
            >
              <a-icon type="camera" class="camera-img" />
            </a-upload>
          </div>
          <a-textarea
            v-model="sendValue"
            placeholder="请输入内容"
            :disabled="!isOnlineDoc"
          />
          <a-button
            type="primary"
            @click="sending"
            class="send-btn"
            :disabled="!isOnlineDoc"
            >发送</a-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { message } from "ant-design-vue";
import BScroll from "@better-scroll/core";
import MouseWheel from "@better-scroll/mouse-wheel";
import ObserveDom from "@better-scroll/observe-dom";
BScroll.use(ObserveDom);
import ChatItem from "@/components/chat";
BScroll.use(MouseWheel);
import websocket from "@/utils/websocket.js";
import { mapGetters } from "vuex";
import {
  getChatMessage,
  getOnlineDoctorInfo,
  getdoctorListRecord,
} from "@/api/chat";
import { getUploadParams } from "@/api/upload";
import { uuid } from "@/utils";
const chatItems = [];
export default {
  name: "",
  data() {
    return {
      isOnlineDoc:false,
      activedIndex: 0,
      sendValue: "",
      chatItems,
      bs: null,
      dataList: [],
      // 这个地址是后端给的，用来连接websocket。 加密wss 未加密ws
      wsUrl: "",
      doctorList: [],
      selectDoctor: {},
      userInfo: {},
      dataObj: {},
      isMoreMsg: true,
      pageNum: 1,
    };
  },
  components: {
    "chat-item": ChatItem,
  },

  created() {
    // localStorage.setItem('clientId', 'user-1')
    this.userInfo =
      sessionStorage.getItem("userInfo") &&
      JSON.parse(sessionStorage.getItem("userInfo"));
    websocket.Init(this.userInfo.userNo);
    this.getdoctorRecord();
  },
  updated() {
    this.$nextTick(() => {
      this.init();
      this.$previewRefresh();
    });
  },
  mounted() {
    this.$nextTick(() => {
      this.init();
      this.$on("ItemImageLoad", this.init());
      // let Lis = this.$refs.scroll.querySelectorAll('li') // 查找所有li元素
      // this.scroll.scrollToElement(Lis[Lis.length - 1], 300) // 滑动到指定元素,设置动画300ms
    });
  },
  beforeDestroy() {
    this.bs.destroy();
    // this.handleClose()
  },
  computed: {
    ...mapGetters({
      ossParams: "upload/getOssParams",
    }),
    // 从store中获取接收到的信息
    getSocketMsg() {
      return this.$store.state.user.webSocketMsg;
    },
  },
  watch: {
    getSocketMsg: {
      handler: function (val) {
        if (val) {
          let data = JSON.parse(val);
          if (typeof data == "object" && data && data.sendType == "1") {
            this.chatItems.push(data);
          }
        }
      },
      immediate: true,
    },
  },
  methods: {
    ItemImageLoad() {
      this.$_.debounce(this.init, 200);
    },
    // 查询最近聊天医生
    //排除10000029 李来亮 心理老师，只需要咨询老师
    async getdoctorRecord() {
      const { code, data } = await getdoctorListRecord(this.userInfo.userNo);
      if (code == 200) {
        if (data.length > 0) {
          let userNo = "";
          //排除心理老师
          let userNoList = data.filter((e) => {
            return e != 10000029;
          });

          if (userNoList.length > 0) {
            userNo = userNoList[0];
            this.selectDoctor = {
              userNo,
            };
            this.getDoctorList();
            this.chatItems = [];
            this.getMessage();
          } else {
            this.getDoctorList();
            this.chatItems = [];
            this.getMessage();
          }
        } else {
          this.getDoctorList();
          this.chatItems = [];
          this.getMessage();
        }
      }
    },
    moreMsg() {
      this.pageNum++;
      this.getMessage();
    },
    //获取在线医生
    async getDoctorList() {
      const { code, data } = await getOnlineDoctorInfo();
      if (code == 200) {
        if (data.length > 0) {
          //排除李来亮 心理老师
          this.doctorList = data.filter((e) => {
            return e.userNo != 10000029;
          });
          if (this.doctorList.length > 0) {
            this.isOnlineDoc = true;
            if (this.selectDoctor.userNo) {
              //some() 判断是否满足，返回Boolean
              let TF = this.doctorList.some(
                (item) => item.userNo == this.selectDoctor.userNo
              );
              if (!TF) {
                this.selectDoctor = data && data[0];
              }
            } else {
              this.selectDoctor = data && data[0];
            }
          } else {
            this.isOnlineDoc = false;
          }
        } else {
          this.isOnlineDoc = false;
        }
      }
    },
    async getMessage() {
      const params = {
        userNo: this.userInfo.userNo,
        pageNum: this.pageNum,
        pageSize: 5,
        // toUserId: this.selectDoctor.userNo
      };
      const { code, data } = await getChatMessage(params);
      if (code == 200) {
        if (data.length > 0) {
          console.log(data, "22222");
          this.chatItems = [...data, ...this.chatItems];
          this.isMoreMsg = true;
          this.$previewRefresh();
        } else {
          this.isMoreMsg = false;
        }
      }
    },
    async beforeUpload(param) {
      let file = param.file; // 得到文件的内容
      const isJpgOrPng =
        file.type === "image/jpeg" || file.type === "image/png";
      if (!isJpgOrPng) {
        this.$message.error("上传不上图片");
        return false;
      }
      const isLt2M = file.size / 1024 / 1024 < 10;
      if (!isLt2M) {
        this.$message.error("上传图片不能超过 10MB!");
        return false;
      }
      await this.$store.dispatch("upload/setOssParams", {
        file,
      });
      const { data } = await this.$store.dispatch("upload/setUploadFile");
      try {
        if (data) {
          this.$message.success("发送成功");
          const params = {
            content: data,
            // createTime: new Date(),
            fromUserId: this.userInfo.userNo,
            isRead: "1",
            messageType: "2",
            sendType: "1",
            toUserId: this.selectDoctor.userNo,
          };
          websocket.Send(params);
          this.sendValue = "";
          this.chatItems.push(params);
        }
      } catch (error) {
        this.$message.error("发送失败", "error");
      }
    },
    // better-scroll的代码
    init() {
      if (!this.bs) {
        this.bs = new BScroll(this.$refs.scroll, {
          pullUpLoad: true,
          scrollY: true, // 上下滚动
          click: true, // 开启点击事件
          startY:
            document.querySelector(".scroll-wrapper").clientHeight -
            this.$refs.scroll.scrollHeight -
            100, // 初始高度
          mouseWheel: true, // 鼠标滚动
          probeType: 3, // listening scroll hook
        });
      } else {
        this.bs.refresh();
        this.bs.scrollTo(0, this.bs.maxScrollY);
      }
      // // 下面的不要也行，官网抄的顺便留下来了
    },
    async sending() {
      const params = {
        content: this.sendValue,
        // createTime: new Date(),
        fromUserId: this.userInfo.userNo,
        isRead: "1",
        messageType: "1",
        sendType: "1",
        toUserId: this.selectDoctor.userNo,
      };
      websocket.Send(params);
      this.sendValue = "";
      if (websocket.getStatus() == "已连接") {
        this.chatItems.push(params);
      } else {
        message.error(websocket.getStatus(), "请重试");
        await this.getDoctorList();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.flex {
  display: flex;
  justify-content: center;
  background: #f0f2f5;
  width: 1080px;
  padding: 30px 0;
  margin: 20px auto;
  border-radius: 8px;
}

.more-msg {
  margin: auto;
  text-align: center;
  cursor: pointer;
  color: #cfbfbf;
}

.list {
  overflow-y: auto;
  width: 325px;
  height: 680px;
  background: inherit;
  background-color: #ffffff;

  .list-item {
    display: flex;
    margin-bottom: 16px;
    border-radius: 8px;
    border-bottom: 1px solid #e8e8e8;
    align-items: center;
    cursor: pointer;

    img {
      width: 40px;
      height: 40px;
      margin: 12px;
    }

    .list-pro-name {
      .item-name,
      .item-time {
        margin: 4px 0;
      }
    }
  }
}

.upload-img {
  margin: 10px 0;
  padding-left: 10px;

  .camera-img {
    cursor: pointer;
  }
}
.ant-upload.ant-upload-disabled {
  .camera-img {
    cursor: not-allowed;
  }
}

.sendBox {
  margin: 10px 0;
  width: 980px;
  padding-top: 5px;

  .ant-input {
  }

  .send-btn {
    margin-top: 12px;
    float: right;
  }
}

.scroll-box {
  padding: 10px 0;
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  background-color: #fcfcfc;
}

.scroll-wrapper {
  margin: auto;
  width: 980px;
  height: 520px; // 留一些空间给 打字的地方 和 header
  overflow: hidden; // 非常之关键
}

.actived {
  // border-bottom: 2px solid #3F86FF !important;
  // background-color: #ffffff !important;
  background: linear-gradient(90deg, #82b0ff 0%, #3e83f9 100%);
  box-shadow: 0px 4px 6px 0px rgba(160, 160, 160, 0.25);
}
h3 {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 30px;
}
</style>
